<template>
  <v-layout>
    <v-dialog v-model="dialog" scrollable max-width="640px">
      <v-card>
        <v-card-text class="font-weight-light text-xs-left title underlineheadline bluetext">
          Zusatz Dokumentfelder bearbeiten
        </v-card-text>
        <v-card-text style="overflow: auto; max-height: 400px">
          <v-tabs
            v-model="active"
            ref="myTabs"
            color="#3271b3"
            dark
            slider-color="#71cbf4"
          >
            <v-tab
              key="Tab1"
              ref="tab1"
              class="text-none"
            >
              Zusatz Felder
            </v-tab>
            <v-tab
              key="Tab2"
              ref="tab2"
              dark
              class="text-none"
            >
              Automatische Zuweisung
            </v-tab>
            <v-tab-item
              key="Tab1"
            >
              <v-layout class="pa-4" row wrap>
                <v-flex xs12 class="text-left">
                  Bitte wähle Feldtyp und Beschreibung aus.
                </v-flex>
                <v-flex xs3 class="pa-1">
                  <v-select v-model="widgetTyp" :items="widgetList" label="Feldtyp"></v-select>
                </v-flex>
                <v-flex xs3 class="pa-1">
                  <v-text-field v-model="widgetName" label="Feldname" @change="updateTechName()"></v-text-field>
                </v-flex>
                <v-flex xs2 class="pa-1" v-if="widgetTyp === 'Currency'">
                  <v-text-field v-model="widgetValueLabel" label="Währung"></v-text-field>
                </v-flex>

                <v-flex xs4 class="pa-2">
                  <v-btn class="text-none" color="examenis" outline flat @click="addFeld">Hinzufügen</v-btn>
                </v-flex>
              </v-layout>
              <v-layout row wrap class="pa-4 pt-0">
                <v-flex xs12>
                  <v-data-table
                    :headers="headers"
                    :items="tableItems"
                    hide-actions
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td class="text-xs-left">{{ props.item.name }} <span v-if="props.item.labelValue && props.item.labelValue.length > 0">in {{props.item.labelValue}}</span>
                      </td>
                      <td class="text-xs-left">{{ props.item.typ }}</td>
                      <td class="justify-center layout px-0">
                        <v-icon
                          small
                          @click="deleteItem(props.item)"
                        >
                          delete
                        </v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item
              key="Tab2"
            >
              <v-layout class="pa-4" row wrap>
                <v-flex xs12 class="text-left">
                  Kategorie autmatisch zuweisen wenn Wort zu finden ist.
                </v-flex>
                <v-flex xs12 class="text-left">
                  <v-text-field v-model="categorySelectWord" label="Wort"></v-text-field>
                </v-flex>
              </v-layout>

            </v-tab-item>
          </v-tabs>
        </v-card-text>

        <v-card-actions>
          <v-btn class="text-none" color="black" outline flat @click="dialog = false">abbrechen</v-btn>
          <v-spacer></v-spacer>
          <v-btn class="text-none" color="examenis" outline flat @click="closeDialog">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
// import Vue from 'vue'

export default {
  name: 'DialogConfigExtraFields',
  components: {},
  props: ['onCloseEventName'],
  methods: {
    addFeld: function () {
      let cmp = this
      if (cmp.widgetTyp !== 'Currency') {
        this.widgetValueLabel = ''
      }
      let entry = {
        id: cmp.tableItems.length,
        key: cmp.widgetId,
        name: cmp.widgetName,
        labelValue: cmp.widgetValueLabel,
        typ: cmp.widgetTyp
      }
      this.tableItems.push(entry)
    },
    closeDialog: function () {
      this.dialog = false
      var that = this
      this.$emit('onSave', {
        item: that.cellData,
        extraFields: that.tableItems,
        categorySelectWord: that.categorySelectWord
      })
    },
    updateTechName () {
      this.widgetId = this.widgetName.toLowerCase().trim()
      this.widgetId = this.widgetId.replace(/[^a-zA-Z0-9]/g, '')
    },
    open: function (item) {
      console.log('item', item)
      this.cellData = item
      this.categorySelectWord = item.categorySelectWord
      this.dialog = true
      this.widgetList = []
      this.widgetList.push({value: 'Currency', text: 'Währung'})
      this.widgetList.push({value: 'Text', text: 'Text'})
      this.widgetList.push({value: 'Datum', text: 'Datum'})
      this.widgetList.push({value: 'Number', text: 'Zahl'})

      if (item && item.extraFields) {
        this.tableItems = item.extraFields
      }
      if (!this.tableItems || !(this.tableItems instanceof Array)) {
        this.tableItems = []
      }
    },
    deleteItem (item) {
      let index = this.tableItems.indexOf(item)
      this.tableItems.splice(index, 1)
    }
  },
  data () {
    return {
      cellData: {},
      categorySelectWord: '',
      active: null,
      widgetTyp: 'Currency',
      widgetName: 'Neues Feld',
      tableItems: [],
      widgetId: '',
      widgetValueLabel: '€',
      widgetList: [],
      dialog: false,
      name: '',
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Typ',
          align: 'left',
          sortable: false,
          value: 'typ'
        },
        {text: 'Aktion', value: 'action'}
      ]
    }
  },
  mounted () {
    //
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/DialogConfigExtraFields.vue